import { NgModule } from '@angular/core';
import { CollectionService } from './collection.service';

@NgModule({
  providers: [CollectionService]
})
export class CollectionModule {}
